import LightModeLogo from 'assets/images/shift4LogoLight.svg';

interface Shift4LogoProps {
  width?: number;
  height?: number;
}

export const Shift4Logo = ({ width = 48, height = 10 }: Shift4LogoProps) => {
  return <img width={width} height={height} src={LightModeLogo} alt="Shift4" />;
};
